import { render } from "./Ads.vue?vue&type=template&id=eb643aa0&scoped=true"
import script from "./Ads.vue?vue&type=script&lang=js"
export * from "./Ads.vue?vue&type=script&lang=js"

import "./Ads.vue?vue&type=style&index=0&id=eb643aa0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb643aa0"]])

export default __exports__